import { WlsyBigLogo } from 'components/WlsyBigLogo'
import { getServerName } from 'helpers/getServerName'

export const MobileAuthHeader = () => {
  return (
    <div>
      <div className="flex w-full justify-center px-4 py-3">
        <WlsyBigLogo className="w-[90px]" />
      </div>
      <div className="border-b border-t border-dashed border-gray-200 px-4 py-3 text-sm font-normal uppercase text-gray-400">
        {getServerName()}
      </div>
    </div>
  )
}
